import { type ExperimentClient } from './experiment-client'

export interface ExperimentService {
  // Specific experiment and gate methods will be added here as needed
  // Example methods:
  // isExampleFeatureEnabled(): boolean
  // getExampleExperimentAssignment(): TreatmentOrNull<typeof Experiments.ExampleStatsigExperiment>
}

export class ExperimentsServiceImpl implements ExperimentService {
  private readonly experimentClient: ExperimentClient

  constructor(experimentClient: ExperimentClient) {
    this.experimentClient = experimentClient
  }

  // Specific experiment and gate methods will be added here as needed
  // Example implementations:
  /*
  isExampleFeatureEnabled(): boolean {
    return this.experimentClient.isGateEnabled(Gates.ExampleGate)
  }

  getExampleExperimentAssignment(): TreatmentOrNull<typeof Experiments.ExampleExperiment> {
    return this.experimentClient.getTreatment(Experiments.ExampleExperiment)
  }
  */
}
